import React from "react";
import DropdownIcon from "../icons/DropdownIcon";

const DropdownIndicator = () => (
  <div className="dropdown-indicator">
    <DropdownIcon />
  </div>
);

export default DropdownIndicator;
